import type React from "react";
import { ReactComponent as Svg } from "./assets/opening.svg";
import * as styles from "./Icon.module.scss";

type OpeningProps = React.SVGProps<SVGSVGElement>;

export const Opening = ({ className, ...props }: OpeningProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
